import { Heading, Stack, Text, textVariants, vars } from '@etg/wings';
import { Circle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import TimelineWrapper from '../../../common/TimelineWrapper';
import TimelineRow from '../common/TimelineRow';

const originalTimeStyles = css`
  color: #737373;
  text-decoration: line-through;
`;

const timeStyles = (isTimeChanged: boolean) => css`
  background-color: ${isTimeChanged ? vars.colors.signal.caution.tint : 'none'};
`;

interface ItineraryLocationTimeProps {
  airportName: string;
  cityName: string;
  dataTestIdPrefix: string;
  isLastStop?: boolean;
  isStartingPoint?: boolean;
  originalTime: string | null;
  time: string;
}

const ItineraryLocationTime = ({
  airportName,
  cityName,
  dataTestIdPrefix,
  isLastStop,
  isStartingPoint,
  originalTime,
  time,
}: ItineraryLocationTimeProps) => {
  const borderColorBefore = isStartingPoint
    ? vars.colors.inputs.border
    : vars.colors.decoration.dark;
  const borderColorAfter = isStartingPoint
    ? vars.colors.decoration.dark
    : vars.colors.inputs.border;
  const borderStyleBefore = isStartingPoint ? 'dashed' : 'solid';
  const borderStyleAfter = isStartingPoint ? 'solid' : 'dashed';
  const isTimeChanged = originalTime !== null && time !== originalTime;

  return (
    <TimelineRow data-testid="itinerary-location-time">
      <Stack align="end" spacing={0}>
        <Stack align="center" spacing={4}>
          <Text
            className={timeStyles(isTimeChanged)}
            data-testid={`${dataTestIdPrefix}-time`}
            variant={textVariants._18_EMPHASIZED}
          >
            {time}
          </Text>
          {isTimeChanged && (
            <Text
              className={originalTimeStyles}
              data-testid={`${dataTestIdPrefix}-original-time`}
              variant={textVariants._18_EMPHASIZED}
            >
              {originalTime}
            </Text>
          )}
        </Stack>
      </Stack>
      <TimelineWrapper
        borderColorAfter={borderColorAfter}
        borderColorBefore={borderColorBefore}
        borderStyleAfter={isLastStop ? '' : borderStyleAfter}
        borderStyleBefore={borderStyleBefore}
        childSize={8}
      >
        <Circle
          color={vars.colors.decoration.dark}
          data-testid={`${dataTestIdPrefix}-circle`}
          height={9.85}
          weight="fill"
          width={20}
        />
      </TimelineWrapper>
      <Stack spacing={0}>
        <Heading data-testid={`${dataTestIdPrefix}-city`} level={4}>
          {cityName}
        </Heading>
        <Text data-testid={`${dataTestIdPrefix}-airportName`}>{airportName}</Text>
      </Stack>
    </TimelineRow>
  );
};

export default ItineraryLocationTime;
